import React from 'react';
import Txt from './Txt';
import Button from 'components/bootstrap/Button';
import { useTranslation } from 'react-i18next';

// 카드 공통 컴포넌트 (card_area / card_header / card_body 클래스를 대신 붙여줌)
// - className: 'approval_status_card' 같은 개별 클래스를 추가로 전달
// - ...rest: id, onClick, aria-* 등 나머지 props 를 그대로 div 에 전달

// 사용법:
// <CardBox>
//		<CardBox.Header></CardBox.Header>
//		<CardBox.Body></CardBox.Body>
// </CardBox>

const CardBox = ({ className = '', children, ...rest }) => {
	return (
		<div className={`card_area ${className}`.trim()} {...rest}>
			{children}
		</div>
	);
};

const Header = ({
	className = '',
	children,
	title = null,
	btnMoreTo = null,
	btnOnClick = null,
	...rest
}) => {
	const { t } = useTranslation();
	const has_more_btn = btnMoreTo !== null || btnOnClick !== null;

	return (
		<div className={`card_header ${className}`.trim()} {...rest}>
			{/* 타이틀 */}
			{title && <Txt variant='h_section'>{title}</Txt>}
			{/* 더보기 있는 경우 */}
			{has_more_btn && (
				<Button
					tag='a'
					to={btnMoreTo ? btnMoreTo : undefined}
					className='btn_more_link'
					onClick={btnOnClick}
				>
					<Txt as='span' variant='body_lg' weight='regular' color='purple'>{t('common.label.seeMore')}</Txt>
				</Button>
			)}
			{children}
		</div>
	);
};

const Body = ({ className = '', children, ...rest }) => {
	return (
		<div className={`card_body ${className}`.trim()} {...rest}>
			{children}
		</div>
	);
};

// <CardBox.Header>, <CardBox.Body> 형태로 쓸 수 있게 연결
CardBox.Header = Header;
CardBox.Body = Body;

export default CardBox;